import React from 'react';
import { Link } from 'react-router-dom';
import './CaseStudies.css';
import ContactCTA from '../../components/ContactCTA/ContactCTA';

const CaseStudies = ({ isHomePage }) => {
  const caseStudies = [
    {
      id: 1,
      title: "UI/UX Design",
      description: "探索界面设计的艺术，创造直观且美观的用户体验",
      image: "/images/ui.png",
      link: "/case-studies/ui-design"
    },
    {
      id: 2,
      title: "Comfyui Project",
      description: "深入用户体验设计，打造流畅自然的交互体验",
      image: "/images/comfyui.png",
      link: "/case-studies/comfyui-project"
    }
  ];

  return (
    <div className={`case-studies-page ${isHomePage ? 'home-section' : ''}`}>
      <div className="page-header">
        <h1>
          {isHomePage ? 'My Recent CaseStudies' : 'Case Studies'}
        </h1>
        <p>探索我的设计思维和解决方案</p>
        {isHomePage && (
          <Link to="/case-studies" className="see-all-link">
            See All →
          </Link>
        )}
      </div>

      <div className="case-studies-grid">
        {caseStudies.map(study => (
          <div key={study.id} className="case-study-card">
            <div className="case-study-content">
              <h3>{study.title}</h3>
              <p>{study.description}</p>
              <Link to={study.link} className="case-study-link">
                View Case Study <span>→</span>
              </Link>
            </div>
            <div className="case-study-image">
              <img src={study.image} alt={study.title} />
            </div>
          </div>
        ))}
      </div>

      {!isHomePage && <ContactCTA />}
    </div>
  );
};

export default CaseStudies; 